
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.353","height":"14.171"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19831","data-name":"Path 19831","d":"M984.7 1100.57v-2.352a2.726 2.726 0 00-2.733-2.734h-1.417a2.1 2.1 0 00-2.1-1.852h-1.857a2.119 2.119 0 00-2.1 1.852h-1.418a2.731 2.731 0 00-2.733 2.728v2.377c.006.163.141 3.994.165 4.389a3.276 3.276 0 00.693 1.833 2.661 2.661 0 002.05.992c.057 0 .114 0 .171-.006h8.2a2.669 2.669 0 002.262-.993 3.277 3.277 0 00.687-1.821c.026-.4.124-4.235.128-4.4v-.008zm-8.106-5.862h1.855a1.042 1.042 0 01.74.306 1.024 1.024 0 01.253.47h-3.854a1.047 1.047 0 011.001-.776zm-5.171 3.506a1.657 1.657 0 011.659-1.653h8.889a1.649 1.649 0 011.648 1.657v2.058a11.464 11.464 0 01-3.978 1.633 2.392 2.392 0 00-4.268-.008 11.479 11.479 0 01-3.954-1.626v-2.058h-.538zm11.618 7.92a1.617 1.617 0 01-1.382.587h-8.27a1.607 1.607 0 01-1.341-.58 2.2 2.2 0 01-.461-1.228c-.016-.26-.085-2.164-.129-3.369a11.766 11.766 0 004.192 1.49.534.534 0 00.592-.394 1.314 1.314 0 012.538.005.537.537 0 00.52.4.565.565 0 00.071 0 11.753 11.753 0 004.227-1.5 304.08 304.08 0 01-.1 3.375 2.189 2.189 0 01-.462 1.214z","transform":"translate(-970.342 -1093.632)","fill":"#5f6368"}})])
          )
        }
      }
    